import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../Button";

export const WorkThrough = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  const [walkthrough, setWalkthrough] = useState(0);

  // Preload both videos when component mounts
  useEffect(() => {
    const preloadVideo = (src: string) => {
      const video = document.createElement("video");
      video.preload = "auto";
      video.src = src;
      video.load();
    };

    preloadVideo("/gif/walkthrough-2.mp4");
  }, []);

  return (
    <div className="absolute top-0 left-0 right-0 bottom-0 bg-[#141517] flex flex-col items-center pt-10 pb-20 h-full justify-evenly">
      <div className="text-size-16 text-center px-6">
        {walkthrough === 0
          ? t("scan.facePalmToCamera")
          : t("scan.moveFingersToConnectDots")}
      </div>

      <video
        src={
          walkthrough === 0
            ? "/gif/walkthrough-1.mp4"
            : "/gif/walkthrough-2.mp4"
        }
        className=" h-[405px] max-h-[60%]  rounded-2xl"
        style={{ aspectRatio: 270 / 405 }}
        autoPlay
        loop
        muted
        playsInline
      />

      {walkthrough === 0 && (
        <Button
          type="secondary"
          className="border-border-default text-inverted"
          onClick={() => setWalkthrough(1)}
        >
          {t("common.next")}
        </Button>
      )}

      {walkthrough === 1 && (
        <Button className="bg-inverted text-default" onClick={onClick}>
          {t("scan.imReady")}
        </Button>
      )}
    </div>
  );
};
